import { Exponea } from '@df/module-exponea/exponea.types';
import { NICmsContentField } from '@icms/core/content';
import findIndex from 'lodash-es/findIndex';
import { ILocalModelCarouselData } from '../local-model-carousel/local-model-carousel.interface';

export function addExponeaRecommendationsVariant(fields: NICmsContentField.IField[]): NICmsContentField.IField[] {
    const variantIndex = findIndex(fields, i => i.key === 'variant');

    if (variantIndex) {
        const variant = fields[variantIndex] as NICmsContentField.IChoiceField;

        if (Array.isArray(variant?.options)) {
            const key: string = Exponea.recommendationsEngineId;

            variant.options.push({ key, title: 'Exponea Recommendations' });

            const exponeaOptionsField: NICmsContentField.IField = {
                key: Exponea.recommendationsOptions,
                type: NICmsContentField.EFieldType.textarea,
                title: 'Exponea Recommendations Options',
                canShow: (data: ILocalModelCarouselData) => data?.variant === key
            };

            fields.splice(variantIndex + 1, 0, exponeaOptionsField);
        }
    }

    return fields;
}
